import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

/**
 * Loading Overlay Component
 * Displays loading state for connecting, reconnecting, or screen sharing
 */
function LoadingOverlay({ 
  type = 'connecting', 
  errorMessage = null 
}) {
  const isConnecting = type === 'connecting';
  const isReconnecting = type === 'reconnecting';
  const isScreenSharing = type === 'screen-sharing';
  const isRemoteScreenSharing = type === 'remote-screen-sharing';

  if (!isConnecting && !isReconnecting && !isScreenSharing && !isRemoteScreenSharing) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 100,
      }}
    >
      <CircularProgress 
        size={80} 
        sx={{ 
          color: isConnecting ? 'primary.main' : 
                 isScreenSharing || isRemoteScreenSharing ? 'info.main' : 
                 'warning.main', 
          mb: 3 
        }} 
      />
      
      <Typography variant="h6" sx={{ color: 'white', mb: 1 }}>
        {isConnecting ? 'Connecting...' : 
         isReconnecting ? 'Reconnecting...' :
         isScreenSharing ? 'You are sharing screen' :
         'Other participant is sharing screen'}
      </Typography>
      
      <Typography 
        variant="body2" 
        sx={{ 
          color: 'rgba(255, 255, 255, 0.7)', 
          mb: (isReconnecting && errorMessage) || isScreenSharing || isRemoteScreenSharing ? 2 : 0,
          textAlign: 'center', 
          px: 3 
        }}
      >
        {isConnecting 
          ? 'Setting up your video connection' 
          : isReconnecting
          ? errorMessage || 'Connection interrupted. Trying to reconnect...'
          : isScreenSharing
          ? 'Preparing your screen share...'
          : 'Loading screen share...'
        }
      </Typography>
      
      {(isReconnecting || isScreenSharing || isRemoteScreenSharing) && (
        <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.5)' }}>
          {isReconnecting 
            ? 'Please wait while we restore your connection'
            : 'Please wait'
          }
        </Typography>
      )}
    </Box>
  );
}

export default LoadingOverlay;
